/**
 * Floating share control — icon button with small "Share" label beneath.
 */
import React from 'react';
import { triggerShare } from '../utils/shareContent';
import { useLanguage } from '../context/LanguageContext';
import './ShareFloating.css';

const ShareFloatingButton = ({
  title,
  url,
  text,
  openEmailModal,
  showSuccess,
  ariaLabel,
  titleAttr,
}) => {
  const { t } = useLanguage();
  const label = titleAttr || t.ui.share.shareThisPage;

  return (
    <div className="share-floating-stack">
      <button
        type="button"
        className="share-btn-floating"
        onClick={() =>
          triggerShare({
            title,
            url,
            text,
            openEmailModal,
            showSuccess,
            copiedMessage: t.ui.share.linkCopied,
          })
        }
        title={label}
        aria-label={ariaLabel || label}
      >
        <img src="/icons/share-icon.svg" alt="" />
      </button>
      <span className="share-floating-label" aria-hidden="true">
        {t.ui.share.label}
      </span>
    </div>
  );
};

export default ShareFloatingButton;
